module.exports = __webpack_public_path__ + "assets/img/DS-room3 (5).cbe97cb3.jpg";